import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="container mx-auto px-4 text-center">
        <p className="text-gray-400">
          © {new Date().getFullYear()} Rushikesh Chavan. All rights reserved.
        </p>
        <p className="text-gray-500 mt-2 text-sm">
          Built with React, Tailwind CSS, and ❤️
        </p>
      </div>
    </footer>
  );
};

export default Footer;

